var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import firebase from 'firebase/app';
import 'firebase/auth';
import { GoogleSignInResult } from '../definitions';
export const googleSignInWeb = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().useDeviceLanguage();
        const userCredential = yield firebase.auth().signInWithPopup(provider);
        const { credential } = userCredential;
        return new GoogleSignInResult(credential.idToken);
    }
    catch (e) {
        return Promise.reject(e);
    }
});
//# sourceMappingURL=google.provider.js.map